<template>
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.58791 6.71094C8.02859 6.71094 6.71094 8.02859 6.71094 9.58791C6.71094 11.1472 8.02859 12.4649 9.58791 12.4649C11.1472 12.4649 12.4649 11.1472 12.4649 9.58791C12.4649 8.02859 11.1472 6.71094 9.58791 6.71094Z"
      fill="white"
    />
    <path
      d="M17.2619 2.87698H14.7819L12.1859 0.280986C12.097 0.191759 11.9913 0.120997 11.875 0.0727735C11.7586 0.0245503 11.6339 -0.00018168 11.5079 1.00471e-06H7.67194C7.54598 -0.00018168 7.42123 0.0245503 7.30487 0.0727735C7.18851 0.120997 7.08283 0.191759 6.99393 0.280986L4.39794 2.87698H1.91798C0.860216 2.87698 0 3.73719 0 4.79496V15.3439C0 16.4016 0.860216 17.2619 1.91798 17.2619H17.2619C18.3196 17.2619 19.1798 16.4016 19.1798 15.3439V4.79496C19.1798 3.73719 18.3196 2.87698 17.2619 2.87698ZM9.58992 14.3849C6.99105 14.3849 4.79496 12.1888 4.79496 9.58992C4.79496 6.99105 6.99105 4.79496 9.58992 4.79496C12.1888 4.79496 14.3849 6.99105 14.3849 9.58992C14.3849 12.1888 12.1888 14.3849 9.58992 14.3849Z"
      fill="white"
    />
  </svg>
</template>
